import { Download } from "lucide-react";

export default function FlyerCard({ dark = false }) {
  return (
    <a
      href="/brochures/mr-kwila-company-profile.pdf"
      target="_blank"
      rel="noreferrer"
      data-testid="flyer-download-card"
      className={`group flex items-center gap-4 rounded-sm border p-4 transition-shadow hover:ring-2 hover:ring-kwila ${
        dark ? "border-cream/25 bg-cream/5" : "border-ink/15 bg-cream"
      }`}
    >
      <img
        src="/brochures/profile-cover.png"
        alt="Mr Kwila company profile flyer cover"
        className="h-20 w-auto rounded-[2px] border border-ink/10 shadow-sm"
      />
      <div>
        <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-kwila">Download our flyer</p>
        <p className={`mt-1 font-display text-xl leading-tight ${dark ? "text-cream" : "text-ink"}`}>
          Mr Kwila — Company Profile
        </p>
        <p className={`mt-0.5 text-xs ${dark ? "text-cream/60" : "text-sand"}`}>A4 PDF · About · Kwila · Trade</p>
      </div>
      <Download
        size={18}
        className={`ml-auto shrink-0 transition-colors group-hover:text-kwila ${dark ? "text-cream/60" : "text-sand"}`}
      />
    </a>
  );
}
